import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {Store} from "@ngrx/store";
import {IClinicalDashboardAndSelectedState} from "@ispm-client/modules/clinical-dashboard/store/reducers/clinicaldashboard.reducer";
import {IClinicalTrendType} from "@ispm-client/modules/clinical-dashboard/interfaces/clinica-trends.interface";
import {Observable} from "rxjs";

@Component({
  selector: 'ispm-clinical-trends-graph',
  templateUrl: './clinical-trends-graph.component.html',
  styleUrls: ['./clinical-trends-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClinicalTrendsGraphComponent implements OnInit {
  public store$: Store<IClinicalDashboardAndSelectedState>;
  public groups: Observable<Array<IClinicalTrendType>>;

  constructor(private cd: ChangeDetectorRef,
              private store: Store<any>,) {
    this.store$ = store.select('clinicalDashboard') as any;
  }


  ngOnInit(): void {
    this.groups = this.store$.select('trendGroups');
  }


}
